// extracted by mini-css-extract-plugin
export default {"header__description":"ReceiptBillsReport_header__description__Nr6CG"};